{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            Copyright (c) 2025                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit lib.propertyserializer;

{$IFDEF PAS2JS}{$MODE DELPHI}{$ENDIF}
interface

uses
  WEBLib.DataGrid.Common,
  Classes, web, JS, WEBLib.Controls, Types, System.SysUtils, jsdelphisystem;


type

  TJSPropertySerializer = class
  private
    SL: TJSArray;
    Events: TJSObject;
  public
    constructor Create;
    function AsJsObject(IncludeEvents: Boolean = True): TJSObject;
    function AsJsonString(IncludeEvents: Boolean = True; FunctionPrefix: String = ''): String;
    function AsJsArray(): TJSArray;

    procedure IterateEvents(Callback: TProc<String, String, TJSValue>);

    procedure Add(Name: String; Value: Double; DefaultValue: Double = 0); overload;
    procedure Add(Name: String; Value: Boolean; DefaultValue: Boolean = False); overload;
    procedure Add(Name: String; Value: String; DefaultValue: String = ''); overload;
    procedure Add(Name: String; Value: Integer; DefaultValue: Integer = 0); overload;
    procedure Add(Name: String; Value: Pointer; VarName: String); overload;
    procedure Add(Name: String; Value: TJSValue; DefaultValue: TJSValue); overload;
    procedure AddCollectionAsString<CollectionItemType: TCollectionItem>
      (Name: String; Value: TOwnedCollection; Assignment: TFunc<CollectionItemType, String, Integer, String>);
    procedure AddCollectionAsObject<CollectionItemType: TCollectionItem>
      (Name: String; Value: TOwnedCollection; Assignment: TProc<CollectionItemType, TJSArray>);
    procedure AddCollectionAsArray<CollectionItemType: TCollectionItem>
      (Name: String; Value: TOwnedCollection; Assignment: TProc<CollectionItemType, TJSArray>);

    procedure AddType<T>(Name: String; Value: T; GetValueCallback: TFunc<T, TJSValue>);

  end;

implementation

procedure TJSPropertySerializer.Add(Name: String; Value: String; DefaultValue: String = '');
begin
  if Value <> DefaultValue then
  begin
    SL.push(Name);
    SL.push(Value);
  end;
end;
procedure TJSPropertySerializer.Add(Name: String; Value: Integer; DefaultValue: Integer = 0);
begin
  if Value <> DefaultValue then
  begin
    SL.push(Name);
    SL.push(Value);
  end;
end;
procedure TJSPropertySerializer.Add(Name: String; Value: Double; DefaultValue: Double = 0);
begin
  if Value <> DefaultValue then
  begin
    SL.push(Name);
    SL.push(Value);
  end;
end;
procedure TJSPropertySerializer.Add(Name: String; Value: Boolean; DefaultValue: Boolean = False);
begin
  if Value <> DefaultValue then
  begin
    if Value then
    begin
      SL.push(Name);
      SL.push(True)
    end
    else
    begin
      SL.push(Name);
      SL.push(False);
    end;
  end;
end;
procedure TJSPropertySerializer.AddCollectionAsString<CollectionItemType>(
  Name: String; Value: TOwnedCollection; Assignment: TFunc<CollectionItemType, String, Integer, String>);
var
  Item: TCollectionItem;
  CollectionItem: CollectionItemType;
  StrValue: String;
  Count: Integer;
begin
  if Assigned(Value) and (Value.Count > 0) and Assigned(Assignment) then
  begin
    StrValue := '';
    Count := 0;
    for Item in Value do
    begin
      CollectionItem := Item as CollectionItemType;
      if CollectionItem <> nil then
      begin
        StrValue := Assignment(CollectionItem, StrValue, Count);
        Inc(Count);
      end;
    end;
    SL.push(Name);
    SL.push(StrValue);
  end;
end;
procedure TJSPropertySerializer.AddCollectionAsObject<CollectionItemType>(
  Name: String; Value: TOwnedCollection; Assignment: TProc<CollectionItemType, TJSArray>);
var
  Item: TCollectionItem;
  CollectionItem: CollectionItemType;
  Arr: TJSArray;
begin
  if Assigned(Value) and (Value.Count > 0) and Assigned(Assignment) then
  begin
    Arr := TJSArray._of();
    for Item in Value do
    begin
      CollectionItem := Item as CollectionItemType;
      if CollectionItem <> nil then
      begin
        Assignment(CollectionItem, Arr);
      end;
    end;
    SL.push(Name);
    SL.push(new(TJSValueDynArray(Arr)));
  end;
end;
procedure TJSPropertySerializer.AddCollectionAsArray<CollectionItemType>(
  Name: String; Value: TOwnedCollection; Assignment: TProc<CollectionItemType, TJSArray>);
var
  Item: TCollectionItem;
  CollectionItem: CollectionItemType;
  Arr: TJSArray;
begin
  if Assigned(Value) and (Value.Count > 0) and Assigned(Assignment) then
  begin
    Arr := TJSArray._of();
    for Item in Value do
    begin
      CollectionItem := Item as CollectionItemType;
      if CollectionItem <> nil then
      begin
        Assignment(CollectionItem, Arr);
      end;
    end;
    SL.push(Name);
    SL.push(Arr);
  end;
end;
procedure TJSPropertySerializer.Add(Name: String; Value: Pointer; VarName: String);
begin
  if Assigned(Value) then
  begin
    SL.push(Name);
    SL.push(Value);
    Events.Properties[Name] := VarName;
  end;
end;

procedure TJSPropertySerializer.AddType<T>(
  Name: String; Value: T; GetValueCallback: TFunc<T, TJSValue>);
var
  ReturnValue: TJSValue;
begin
  if Assigned(GetValueCallback) then
  begin
    ReturnValue := GetValueCallback(Value);
    if ReturnValue <> nil then
    begin
      SL.push(Name);
      SL.push(ReturnValue);
    end;
  end;
end;
procedure TJSPropertySerializer.Add(Name: String; Value: TJSValue; DefaultValue: TJSValue);
begin
  if Value <> DefaultValue then
  begin
    SL.push(Name);
    SL.push(Value);
  end;
end;



constructor TJSPropertySerializer.Create;
begin
  SL := TJSArray._of;
  Events := TJSObject.new;
end;

function TJSPropertySerializer.AsJsArray: TJSArray;
begin
  Result := SL;
end;

{$IFDEF PAS2JS}
function _typeof(Value: TJSValue) : String external name 'typeof';
{$ELSE}
function _typeof(Value: TJSValue) : String;
begin
  // Dummy function
end;
{$ENDIF}


function TJSPropertySerializer.AsJsObject(IncludeEvents: Boolean = True) : TJSObject;
var
  I, Len: Integer;
  TypeName, CurrentName: String;
  Props: TJSArray;
begin
  if IncludeEvents then
  begin
    Result := new(TJSValueDynArray(SL));
  end
    else
  begin
    Len := SL.Length;
    Props := TJSArray._of;
    for I := 0 to len - 1 do
    begin
      if (I mod 2) = 0 then
      begin
        CurrentName := String(SL[I]);
      end
        else
      begin
        TypeName := _typeof(SL[I]);
        if TypeName <> 'function' then
        begin
          Props.push(CurrentName);
          Props.push(SL[I]);
        end;
      end;
    end;
    Result := new(TJSValueDynArray(Props));
  end;
end;

function TJSPropertySerializer.AsJsonString(IncludeEvents: Boolean = True; FunctionPrefix: String = '') : String;
var
  I, Len: Integer;
  TypeName, CurrentName: String;
  PrefixString: String;
  EventsString: String;
begin
  Result := 'null';
  PrefixString := '';
  EventsString := '';
  if FunctionPrefix <> '' then
    PrefixString := FunctionPrefix + '.';
  Len := SL.Length;
  if Len > 0 then
    Result := '{';
  for I := 0 to len - 1 do
  begin
    if (I mod 2) = 0 then
    begin
      CurrentName := String(SL[I]);
    end
      else
    begin
      TypeName := _typeof(SL[I]);
      if TypeName = 'function' then
      begin
        if CurrentName = 'init' then
        begin
          // Call the init event
          EventsString := EventsString +
            PrefixString + String(Events.Properties[CurrentName]) + '();';
        end
          else
        begin
          // Assign the event in the init event
          EventsString := EventsString + 'this.on("' + CurrentName +
            '", ' + PrefixString + String(Events.Properties[CurrentName]) + ');';
        end;

      end
        else
      begin
        Result := Result + '"' + CurrentName + '":' + TJSJson.stringify(SL[I]);
      end;
    end;
  end;
  if EventsString <> '' then
  begin
    // We have events that needs to be assigned to the init event
    Result := Result + '"init":function() {' + EventsString + '}';
  end;
  if Len > 0 then
    Result := Result + '}';
end;

procedure TJSPropertySerializer.IterateEvents(Callback: TProc<String, String, TJSValue>);
var
  I, Len: Integer;
  TypeName, CurrentName: String;
begin
  if Assigned(Callback) then
  begin
    Len := SL.Length;
    for I := 0 to len - 1 do
    begin
      if (I mod 2) = 0 then
      begin
        CurrentName := String(SL[I]);
      end
        else
      begin
        TypeName := _typeof(SL[I]);
        if TypeName = 'function' then
        begin
          Callback(CurrentName, String(Events.Properties[CurrentName]), SL[I]);
        end;
      end;
    end;
  end;
end;



end.
